import { useState } from "react";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { GoEye } from "react-icons/go";
import Finance_common_PopUp from "../CommonPopUp";

export default function AnnualVacation_finance({
  globalData,
  setTrigger,
  trigger,
}) {
  const titles = [
    "S.NO",
    "POINT OF HIRE",
    "EMPLOYEE ID",
    "EMPLOYEE NAME",
    "NATIONALITY",
    "ACTUAL PROFESSION",
    "VISA PROFESSION",
    "TOTAL SALARY",
    "CLIENT",
    "VISA PROVIDER",
    "IQAMA NUMBER",
    "IQAMA EXPIRY DATE",
    "ARRIVAL DATE",
    "MOBILIZATION DATE",
    "DEMOBILIZATION DATE",
    "DEMOBILIZATION COMMENTS",
    "IDLE AGING",
    "ENTRY BEFORE DATE",
    "STATUS",
    "ACTION",
  ];

  const [searchWords, setSearchWords] = useState("");
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(globalData?.data);

  const [popUpData, setPopUpData] = useState();
  const [popUp, setPopUp] = useState(false);
  const handleClick = (data) => {
    setPopUp(true);
    setPopUpData(data);
  };

  return (
    <div>
      <div className="flex justify-end gap-x-4 m-4">
        <Search
          searchKey={[
            "employee_id",
            "passport_number",
            "iqama_number",
            "client_id",
            "emp_id",
            "sponsor_id",
          ]}
          setSearchWords={setSearchWords}
        />
        <button
          className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
          // onClick={() => downloadFile()}
        >
          DOWNLOAD
        </button>
      </div>

      <div className="overflow-x-auto m-2" style={{ backgroundColor: "white" }}>
        <table className="min-w-full divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {titles.map((columnName, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                >
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-gray-10">
            {currentList?.map((listItem, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.point_of_hire}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.candidate_id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.nationality}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.actual_profession}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.visa_profession}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.total_salary}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.client}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.visa_provider}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.iqama_number}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.iqama_expiry_date_g}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.arrival_date
                    ? new Date(listItem.arrival_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.mobilization_date
                    ? new Date(listItem.mobilization_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.demobilization_date
                    ? new Date(listItem.demobilization_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.demobilization_comments
                    ? listItem.demobilization_comments
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.idle_aging?.toString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {/* {listItem.demobilization_type} */}
                  {"N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.demobilization_type}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <button
                    onClick={() => {
                      handleClick(listItem);
                    }}
                  >
                    <GoEye fontSize={22} className="ml-2" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {popUp ? (
        <Finance_common_PopUp
          PopUp={popUp}
          setPopUp={setPopUp}
          popUpData={popUpData}
          setTrigger={setTrigger}
          trigger={trigger}
          routeType={"Annual_Vacation"}
        />
      ) : (
        ""
      )}
      <Pagination />
    </div>
  );
}
